import React from "react";
import { Card, Col, Row, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ActionLockSettings from "./ActionLockSettings";
import PrintSetting from "./PrintSetting";
// import {
//   deleteReceiptMessage,
//   updateReceiptMessage,
// } from "../../redux/action/branchActions";

const BranchUserSettings = () => {
  return (
    <div className="page-content-tab">
      <PrintSetting />
      <ActionLockSettings />
    </div>
  );
};

export default BranchUserSettings;
